export default __webpack_public_path__ + "static/media/hint-shape.ce67147e.svg";